import { Link } from "react-router-dom";
import { useT } from "../../lib/i18n";

const TONE_BAR = { red: "bg-red-500", orange: "bg-orange-500", green: "bg-emerald-500", slate: "bg-slate-300", none: "bg-transparent" };

// Compact, cardless list row — the single item style used across Today,
// Agenda, Signals, Scorecard. Left indicator = status/urgency, right =
// always-visible one-tap actions.
export function ListRow({ tone = "none", leading, title, meta, actions, onClick, testid, titleAttr }) {
  const clickable = !!onClick;
  return (
    <div
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={onClick}
      onKeyDown={clickable ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(e); } } : undefined}
      data-testid={testid}
      title={titleAttr}
      className={`relative w-full text-left flex items-center gap-3 py-3 pl-4 pr-3 min-h-[64px] border-b border-slate-100 bg-white transition-colors ${clickable ? "cursor-pointer active:bg-slate-50" : ""}`}
    >
      <span className={`absolute left-0 top-2 bottom-2 w-1 rounded-r ${TONE_BAR[tone] || TONE_BAR.none}`} />
      {leading && <div className="shrink-0 w-12 text-xs font-medium text-slate-500 tabular-nums leading-tight">{leading}</div>}
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-slate-900 leading-snug truncate">{title}</div>
        {meta && <div className="text-xs text-slate-500 mt-0.5 truncate">{meta}</div>}
      </div>
      {actions && <div className="flex items-center gap-1.5 shrink-0" onClick={(e) => e.stopPropagation()}>{actions}</div>}
    </div>
  );
}

export function RowAction({ children, onClick, href, primary = false, testid, title }) {
  const cls = `h-9 min-w-[44px] px-3 rounded-full text-xs font-semibold flex items-center justify-center gap-1 active:scale-95 transition-transform ${
    primary ? "text-slate-900" : "bg-slate-100 text-slate-700"
  }`;
  const style = primary ? { background: "var(--pm-green)" } : undefined;
  if (href) return <a href={href} className={cls} style={style} data-testid={testid} title={title}>{children}</a>;
  return <button type="button" onClick={onClick} className={cls} style={style} data-testid={testid} title={title}>{children}</button>;
}

export function Section({ title, count, to, children, testid }) {
  const t = useT();
  return (
    <section className="mt-8 first:mt-0" data-testid={testid}>
      <div className="flex items-baseline justify-between px-4 mb-1">
        <h2 className="text-base font-semibold tracking-tight text-slate-800">
          {title}{count != null && <span className="ml-2 text-xs font-medium text-slate-400 tabular-nums">{count}</span>}
        </h2>
        {to && <Link to={to} className="text-xs font-medium text-slate-500 active:text-slate-900" data-testid={`${testid}-more`}>{t("Alles")}</Link>}
      </div>
      <div className="border-t border-slate-100">{children}</div>
    </section>
  );
}

export function EmptyRow({ children, testid }) {
  return <div className="mx-4 my-3 py-5 text-center text-sm text-slate-400 border border-dashed border-slate-200 rounded-lg" data-testid={testid}>{children}</div>;
}
